import React from "react"

import Header from "../../../../design-system/header"
import BlogPostSummary from "../../../blog-home/category-section/blog-post-summary"
import { BlogPostPreview } from "../../types"
import * as styles from "./index.module.scss"

interface Props {
  suggestedPosts: BlogPostPreview[]
}

function SuggestionsSection({ suggestedPosts }: Props) {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <Header variant="3" as="h4" className={styles.header}>
          Continue reading
        </Header>
        <div className={styles.grid}>
          {suggestedPosts.map(post => (
            <BlogPostSummary key={post.slug} {...post} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default SuggestionsSection
